import { gql } from '@apollo/client';

import { TFeedback } from 'Components/FeedbackCard/FeedbackCard.helpers';

export type ReviewsQueryResponse = {
  reviewsQuery: TFeedback[];
};

export const reviewsQuery = gql`
  query ReviewsQuery {
    reviewsQuery {
      id
      value
      comment
      createdAt
      user {
        id
        name
        gender
        slug
        avatar
        city
      }
      provider {
        id
        name
        gender
        slug
        avatar
        city
      }
      category {
        id
        name
        slug
      }
    }
  }
`;
